export const IsUserProvider = (data) => {
    return {
      type: 'IsUserProvider',
      payload: data
    }
}